import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const OfferClicksAndViews = () => {
  const { offerViewsAndClicks } = useSelector(
    (state) => state?.merchantReducer
  );

  const [state, setState] = useState({
    series: [
      { name: "Clicks", data: [] },
      { name: "Views", data: [] },
      { name: "Redeemed", data: [] },
    ],
    xaxisCategories: [],
  });

  const [maxDataValue, setMaxDataValue] = useState(10);
  const [step, setStep] = useState(2);
  const [chartOptions, setChartOptions] = useState({
    colors: ["#3C50E0", "#80CAEE", "#49EA80"],
    chart: {
      type: "bar",
      height: 335,
      stacked: false,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        columnWidth: "35%",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: [],
      labels: {
        rotate: 0,
        trim: true,
        hideOverlappingLabels: false,
        style: { fontSize: "12px", whiteSpace: "nowrap" },
      },
      title: {
        text: "Offers",
        style: {
          fontSize: "14px",
          fontWeight: "400",
          color: "#373d3f",
          fontFamily: "Poppins, sans-serif",
        },
      },
      position: "bottom",
    },
    tooltip: {
      shared: true,
      intersect: false,
      x: {
        formatter: (val) => `Title: ${val}`,
      },
      y: {
        formatter: (value) => `${value}`,
      },
    },
    yaxis: {
      min: 0,
      max: 10,
      tickAmount: 5,
      title: {
        text: "Views, Clicks & Redeemed",
        style: {
          fontSize: "14px",
          fontWeight: "400",
          color: "#373d3f",
          fontFamily: "Poppins, sans-serif",
        },
      },
      labels: {
        formatter: (value) => value,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      fontSize: "14px",
    },
    fill: { opacity: 1 },
  });

  useEffect(() => {
    if (offerViewsAndClicks?.data?.length > 0) {
      const clicksData = offerViewsAndClicks.data.map((offer) => offer.clicks || 0);
      const viewsData = offerViewsAndClicks.data.map((offer) => offer.views || 0);
      const redemptionData = offerViewsAndClicks.data.map((offer) => offer?.redemptions || offer?.redemptionCount || 0);
      const titles = offerViewsAndClicks.data.map((offer) => offer.title || "Unknown Offer");

      const maxClicks = Math.max(...clicksData);
      const maxViews = Math.max(...viewsData);
      const maxRedemptions = Math.max(...redemptionData);
      const maxData = Math.max(maxClicks, maxViews, maxRedemptions);

      const newMax = Math.max(maxData, 5);
      const newStep = Math.ceil(newMax / 5);

      setMaxDataValue(newMax);
      setStep(newStep);

      setState({
        series: [
          { name: "Clicks", data: clicksData },
          { name: "Views", data: viewsData },
          { name: "Redeemed", data: redemptionData },
        ],
        xaxisCategories: titles,
      });
      const offerCount = offerViewsAndClicks.data.length;

      let columnWidth;
      if (offerCount <= 3) {
        columnWidth = "35%";
      } else if (offerCount <= 7) {
        columnWidth = "55%";
      } else {
        columnWidth = "65%";
      }

      setChartOptions((prev) => ({
        ...prev,
        plotOptions: {
          bar: {
            columnWidth: columnWidth,
            distributed: false,
          },
        },
        xaxis: { ...prev.xaxis, categories: titles },
        yaxis: {
          ...prev.yaxis,
          max: Math.ceil(newMax / newStep) * newStep,
          tickAmount: Math.ceil(newMax / newStep),
        },
      }));
    }
  }, [offerViewsAndClicks]);

  return (
    <div className="rounded-sm border border-stroke bg-white px-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 summary offersChart">
      <div className="flex flex-col sm:flex-col xl:flex-row justify-between w-full mt-4 mb-4">
        <span className="text-[20px] font-poppins font-[600] text-[black] whitespace-nowrap">
          Offer Views - Clicks - Redeemed
        </span>
      </div>
      {state.series[0]?.data.length > 0 || state.series[1]?.data?.length > 0 || state.series[2]?.data?.length > 0 ? (
        <div className="overflow-x-auto">
          <div id="chartTwo" className="min-w-[10rem]">
            <ReactApexChart
              options={chartOptions}
              series={state.series}
              type="bar"
              height={350}
            />
          </div>
        </div>
      ) : (
        <div className="w-full h-[200px] flex items-center justify-center">
          <div id="chartTwo" className="min-w-[700px]">
            <div className="text-center text-gray-500 text-lg font-medium py-10">
              No Clicks, Views, or Redeemed Found
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfferClicksAndViews;
